export default __webpack_public_path__ + "static/media/resource-parking-featured-image-placeholder.c5ae1923.svg";